import { Component } from "react";
import "../../../assets/web/assets/mobirise-icons2/mobirise2.css";
import "../../../assets/web/assets/mobirise-icons/mobirise-icons.css";
import "../../../assets/tether/tether.min.css";
import "../../../assets/bootstrap/css/bootstrap.min.css";
import "../../../assets/bootstrap/css/bootstrap-grid.min.css";
import "../../../assets/bootstrap/css/bootstrap-reboot.min.css";
import "../../../assets/dropdown/css/style.css";
import "../../../assets/socicon/css/styles.css";
import "../../../assets/theme/css/style.css";
import "../../../assets/mobirise/css/mbr-additional.css";
import { Navbar, Nav } from "react-bootstrap";
import { Modal } from "antd";
import { signOut } from "../../../store/actions/authActions";
import { connect } from "react-redux";

class Header extends Component {
  state = {
    logoutModal: false,
  };
  menuHandler = (m) => {
    if (m.key !== "/logout") {
      window.location = m.key;
    } else {
      this.setState({
        logoutModal: true,
      });
    }
  };

  showModal = () => {
    this.setState({
      logoutModal: true,
    });
  };

  handleOk = () => {
    this.props.signOut();
    this.setState({
      logoutModal: false,
    });
  };

  handleCancel = () => {
    this.setState({
      logoutModal: false,
    });
  };

  render() {
    return (
      <section className="menu menu2 cid-smIpILaFmX" once="menu" id="menu2-0">
        <Navbar
          collapseOnSelect
          expand="lg"
          className="navbar navbar-dropdown navbar-fixed-top navbar-expand-lg"
          style={{ backgroundColor: "rgba(98, 98, 98, 0.5)" }}
        >
          <div className="container-fluid">
            <Navbar.Brand className="navbar-brand" href="/business_dashboard">
              <span className="navbar-caption-wrap">
                <a
                  className="navbar-caption text-white display-7"
                  href="/business_dashboard"
                >
                  Dashboard
                </a>
              </span>
            </Navbar.Brand>
            {/* <Navbar.Toggle aria-controls="responsive-navbar-nav" /> */}
            <Navbar.Toggle
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarNavAltMarkup"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <div className="hamburger">
                <span />
                <span />
                <span />
                <span />
              </div>
            </Navbar.Toggle>
            <Navbar.Collapse
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <Nav className="navbar-nav nav-dropdown nav-right">
                <Nav.Link
                  className="nav-link link text-white text-primary display-4"
                  href="/business_transactions"
                >
                  Transactions
                </Nav.Link>
                <Nav.Link
                  className="nav-link link text-white text-primary display-4"
                  href="/business_deposit"
                >
                  Deposit
                </Nav.Link>

                <Nav.Link
                  className="nav-link link text-white text-primary display-4"
                  href="/business_buy_airtime"
                >
                  Buy Airtime
                </Nav.Link>

                <Nav.Link
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState({
                      logoutModal: true,
                    });
                  }}
                  className="nav-link link text-white text-primary display-4"
                >
                  Logout
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </div>
        </Navbar>
        <Modal
          title="Log Out"
          visible={this.state.logoutModal}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          <p>Are You Sure You Want to Log Out?</p>
        </Modal>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(signOut()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
